import { pbUserPreferences } from './adapters/pb-user-preferences'
import type { UserPreferencesPort } from './domain/user-preferences'

const userPreferencesPort: UserPreferencesPort = pbUserPreferences

export { userPreferencesPort }
